module.exports = require('./helpers/bundle-url').getBundleURL('7A20Q') + "logo.c51670a8.svg";